export default "__VITE_ASSET__DTLyjz13__"